{
  "title": "Sunbeam",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level evocation",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self (60-foot line)",
  "components": "V, S, M (a magnifying glass)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A beam of brilliant light flashes out from your hand in a 5-foot-wide, 60-foot-line. Each creature in the line must make a Constitution saving throw. On a failed save, a creature takes 6d8 radiant damage and is blinded until your next turn. On a successful save, it takes half as much damage and isn’t blinded by this spell. Undead and oozes have disadvantage on this saving throw.",
    "You can create a new line of radiance as your action on any turn until the spell ends.",
    "For the duration, a mote of brilliant radiance shines in your hand. It sheds bright light in a 30-foot radius and dim light for an additional 30 feet. The light is sunlight."
  ],
  "spellLists": ["cleric", "druid", "sorcerer", "wizard"]
}
